var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLegendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 10.9048C22 16.375 17.6154 20.5714 12.5 24C7.01923 20.1905 3 16.375 3 10.9048C3 5.43451 7.25329 1 12.5 1C17.7467 1 22 5.43451 22 10.9048Z",
    fill: "#989899"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9844 8.76924C15.9844 9.43376 15.8076 9.92001 15.543 10.3047C15.2781 10.6898 14.9246 10.9738 14.5696 11.2333C14.5045 11.2808 14.4393 11.3276 14.3746 11.374C14.087 11.5803 13.8089 11.7798 13.5903 12.013C13.3217 12.2996 13.1419 12.6381 13.1419 13.1044V13.1144C13.1419 13.3194 12.9829 13.4844 12.7881 13.4844H11.2373C11.0425 13.4844 10.8835 13.3194 10.8835 13.1144V13.0055C10.8835 12.295 11.0388 11.7744 11.2712 11.3722C11.5037 10.9698 11.8138 10.6849 12.1249 10.4465C12.2415 10.357 12.3581 10.2743 12.4709 10.1943C12.5086 10.1676 12.5458 10.1412 12.5825 10.1149C12.7288 10.0102 12.8659 9.90797 12.9836 9.79962C13.2194 9.5826 13.3785 9.33972 13.3785 9C13.3785 8.70756 13.2743 8.47219 13.0828 8.31019C12.8917 8.14847 12.6153 8.0613 12.2733 8.0613C11.7158 8.0613 11.1475 8.31578 10.6321 8.83335C10.5064 8.9596 10.3099 8.96769 10.1722 8.85531L9.1523 8.02257L9.14242 8.03468L9.1523 8.02257C8.98733 7.88789 8.96823 7.63236 9.11399 7.47552C9.96267 6.56227 11.0651 6.01562 12.5259 6.01562C13.6837 6.01564 14.5482 6.34035 15.1231 6.84623C15.6979 7.35203 15.9844 8.03998 15.9844 8.76924ZM13.4577 16.5C13.4577 17.3163 12.8324 17.9844 12.0364 17.9844C11.2561 17.9844 10.615 17.3162 10.615 16.5C10.615 15.6838 11.2561 15.0157 12.0364 15.0157C12.8324 15.0157 13.4577 15.6837 13.4577 16.5Z",
    fill: "#1C1C1E",
    stroke: "#183254",
    strokeWidth: 0.03125
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegendIcon);
export default __webpack_public_path__ + "static/media/legend_icon.4c1316fab8f2d4b17604cb1edf2b51ce.svg";
export { ForwardRef as ReactComponent };